import { Button, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { Block } from './Block'
import { RemoveAccountDialog } from './RemoveAccountDialog'

export const RemoveAccount: FC = () => {
    const [open, setOpen] = useState(false)

    return (
        <Block>
            <Typography
                sx={{
                    mb: '16px',
                }}
                variant="h4">
                Удаление аккаунта
            </Typography>
            <Typography
                sx={{
                    color: '#5A5F72',
                }}
                variant="body2">
                Внимание! После удаления аккаунта все чаты, данные в хранилище и используемые
                ассистенты будут удалены.
            </Typography>{' '}
            <Typography
                sx={{
                    color: '#5A5F72',
                    mb: '16px',
                    mt: '8px',
                }}
                variant="body2">
                Аккаунт можно будет восстановить в течение 90 дней, после чего восстановление станет
                невозможным.
            </Typography>
            <Button
                onClick={() => setOpen(true)}
                sx={{
                    color: '#EF4848',
                    background: '#F4F4F6',
                }}
                variant="outlined">
                Удалить аккаунт
            </Button>
            <RemoveAccountDialog open={open} onClose={() => setOpen(false)} />
        </Block>
    )
}
